import lodash from 'lodash';
import { findMessageKey } from './source-form-locators';
import AI_FORM_CONTENT_DATA from './resources/layout';

function findMessageFieldPosition(formContentData, messageKey) {
	if (messageKey) {
		for (let i = 0; i < formContentData.length; i++) {
			const row = formContentData[i];
			for (let j = 0; j < row.cells.length; j++) {
				const rowCells = row.cells[j];
				for (let k = 0; k < rowCells.fields.length; k++) {
					if (rowCells.fields[k] === messageKey) {
						return i;
					}
				}
			}
		}
	}
	return -1;
}

function prepareVariableNames(formPrefixId) {
	const formContentData = lodash.cloneDeep(AI_FORM_CONTENT_DATA);
	return formContentData.map((row) => {
		const subId = row.subId + formPrefixId;
		row.cells[0].fields[0] = `${row.cells[0].fields[0]}_${subId}`;
		return row;
	});
}

function processPlainFormContentData(formContentData, messageKey, aiFields) {
	const messagePosition = findMessageFieldPosition(
		formContentData,
		messageKey,
	);
	// Skip if the disclaimer field is not found
	if (messagePosition < 0) {
		return formContentData;
	}
	const resultFormContentData = [
		...formContentData.slice(0, messagePosition + 1),
		...aiFields,
		...formContentData.slice(messagePosition + 1),
	];
	resultFormContentData.map((row, i) => {
		row.order = i;
		return row;
	});
	return resultFormContentData;
}

export default function (formPrefixId, form) {
	const aiFields = prepareVariableNames(formPrefixId);
	const messageKey = findMessageKey(form.fields);
	if (!messageKey) {
		return form;
	}
	// Check if the layout contains multi-part form
	for (let i = 0; i < form.settings.formContentData.length; i++) {
		if (form.settings.formContentData[i].formContentData) {
			// Multi-part form
			form.settings.formContentData[i].formContentData = processPlainFormContentData(
				form.settings.formContentData[i].formContentData,
				messageKey,
				aiFields,
			);
		} else {
			// Single part form
			form.settings.formContentData = processPlainFormContentData(
				form.settings.formContentData,
				messageKey,
				aiFields,
			);
			return form;
		}
	}
	return form;
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/buildFormLayout.js